import { Component, input, model } from "@angular/core";

@Component({
  selector: "av-tab",
  templateUrl: "./tab.component.html",
  styleUrls: ["./tab.component.scss"],
  standalone: false,
})
export class TabComponent {
  readonly label = input<string>(undefined);
  readonly active = model(false);
  readonly disabled = input(false);
  readonly visible = input(true);
  readonly id = input<string>(undefined);
}
